import React from 'react';
import { FlexProps, TextV2, Flex } from '@withjoy/joykit';

interface FreeShippingInlineBannerProps extends FlexProps {
  countriesWithFreeShipping: string[];
}

export const FreeShippingInlineBanner = ({ countriesWithFreeShipping, ...props }: FreeShippingInlineBannerProps) => {
  if (countriesWithFreeShipping.length === 0) {
    return null;
  }

  return (
    <Flex
      justifyContent="center"
      {...props}
    >
      <TextV2
        typographyVariant="button1"
        color="#4951EF"
      >
        Free Shipping to {countriesWithFreeShipping.join(', ')} Addresses
      </TextV2>
    </Flex>
  );
};
